export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/topseller.a7d05f3f.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};